mdApp.directive('logoTile', function(){
    return {
        retrict: 'E',
        scope: true,
        compile: function(){
            // return function(scope, element){
            //     var elments = element[0].getElementsByTagName('*');
            //     var fills = [];
            //     var tileid = element[0].id;
            //     for (var i = 0; i < elments.length; i++) {
            //         var el = elments[i];
            //         var fill = el.getAttribute('fill');
            //         if (fill !== null) {
            //             var idx = fills.indexOf(fill);
            //             var className = el.getAttribute('class');
            //             if (className === null) className = '';
            //             if (idx < 0) {
            //               fills.push(fill);
            //               el.setAttribute('class', className + ` fill fill-${fills.length-1}`);
            //             }else{
            //               el.setAttribute('class', className + ` fill fill-${idx}`);
            //             }
            //             el.setAttribute('fill', '');
            //         }
            //     }
            //     var style = document.createElement("style");
            //     var bgColor = element[0].getAttribute('data-bg-color');
            //     if (bgColor !==null) {
            //         var bdColor = (bgColor.toLowerCase() == "#ffffff")? el.style.backgroundColor: bgColor;
            //         style.innerHTML += `#${tileid}:hover {background-color: ${bgColor}; border-color: ${bdColor};}\n`;
            //     }
            //     for (var i = 0; i < fills.length; i++) {
            //         style.innerHTML += `#${tileid}:hover .fill-${i} {fill: ${fills[i]}}\n`;
            //     }
            //     element[0].appendChild(style);
            // }
            // return function( scope, element ){
                
            // }
        }
    };
});